import { gql } from "@apollo/client";

export const GET_TAKE_OUT_PAGINATION = gql`
  query GetReqTakeOutPagination(
    $page: Int
    $limit: Int
    $pagination: Boolean
    $date: Date
    $no: Int
    $status: ReqTakeOutStatusEnum
  ) {
    getReqTakeOutPagination(
      page: $page
      limit: $limit
      pagination: $pagination
      date: $date
      no: $no
      status: $status
    ) {
      data {
        _id
        checkBy {
          remark
          createdAt
          userId {
            _id
            mainUserId {
              _id
              email
              firstName
              lastName
              latinName
              imageSrc
            }
            role
          }
        }
        checkTakeOutMaterial {
          _id
          qty
          listMaterialUnitId {
            _id
            barcode
            costPerUnit
            imageSrc
            isUse
            materialId {
              materialEnName
              materialKhName
              _id
            }
            qtyInUnit
            remark
            unitId {
              unitEnName
              unitKhName
              _id
            }
          }
        }
        createdAt
        createdBy {
          _id
          mainUserId {
            _id
            email
            firstName
            lastName
            latinName
            imageSrc
          }
          role
        }
        deliverBy {
          createdAt
          userId {
            _id
            mainUserId {
              _id
              email
              firstName
              lastName
              latinName
              imageSrc
            }
            role
          }
        }
        deliveryTakeOutMaterial {
          _id
          listMaterialUnitId {
            _id
            barcode
            costPerUnit
            imageSrc
            materialId {
              _id
              isLongTerm
              materialEnName
              materialKhName
              sizeId {
                _id
                sizeEnName
                sizeKhName
              }
              smallUnitId {
                _id
                unitEnName
                unitKhName
              }
            }
            qtyInUnit
            unitId {
              _id
              unitEnName
              unitKhName
            }
          }
          qty
        }
        no
        receiveBy {
          createdAt
          userId {
            _id
            mainUserId {
              _id
              email
              firstName
              lastName
              latinName
              imageSrc
            }
            role
          }
        }
        receiveTakeOutMaterial {
          _id
          listMaterialUnitId {
            _id
            barcode
            costPerUnit
            imageSrc
            materialId {
              _id
              isLongTerm
              materialEnName
              materialKhName
              sizeId {
                _id
                sizeEnName
                sizeKhName
              }
              smallUnitId {
                _id
                remark
                unitEnName
                unitKhName
              }
            }
            qtyInUnit
            unitId {
              _id
              unitEnName
              unitKhName
            }
            remark
            isUse
          }
          qty
        }
        remark
        reqTakeOutMaterial {
          _id
          listMaterialUnitId {
            _id
            costPerUnit
            imageSrc
            materialId {
              materialKhName
              materialEnName
              _id
              sizeId {
                _id
                sizeEnName
                sizeKhName
              }
            }
            qtyInUnit
            remark
            unitId {
              _id
              unitEnName
              unitKhName
            }
            barcode
          }
          qty
        }
        status
        voidBy {
          createdAt
          userId {
            _id
            mainUserId {
              _id
              email
              firstName
              lastName
              latinName
              imageSrc
            }
            role
          }
          remark
        }
        warehouseId {
          _id
          warehouseName
          location
        }
        userId {
          _id
          mainUserId {
            _id
            email
            firstName
            lastName
            latinName
            imageSrc
          }
          officeId {
            officeKhName
            officeEnName
          }
          role
        }
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const CREATE_REQ_TAKE_OUT = gql`
  mutation CreateReqTakeOut($input: ReqTakeOutInput) {
    createReqTakeOut(input: $input) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_TAKE_OUT = gql`
  mutation DeleteReqTakeOut($id: ID!) {
    deleteReqTakeOut(_id: $id) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const UPDATE_TAKE_OUT = gql`
  mutation UpdateReqTakeOut($id: ID!, $input: ReqTakeOutInput) {
    updateReqTakeOut(_id: $id, input: $input) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const CHECK_TAKE_OUT_MATERIAL = gql`
  mutation CheckTakeOutMaterial(
    $id: ID!
    $status: ReqTakeOutStatusEnum!
    $checkTakeOutMaterial: [ReqTakeOutMaterialInput]
    $remark: String
  ) {
    checkTakeOutMaterial(
      _id: $id
      status: $status
      checkTakeOutMaterial: $checkTakeOutMaterial
      remark: $remark
    ) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELIVERY_TAKE_OUT = gql`
  mutation DeliveryTakeOutMaterial(
    $id: ID!
    $warehouseId: ID!
    $remark: String
    $deliveryTakeOutMaterial: [ReqTakeOutMaterialInput]
    $dateTime: Date
  ) {
    deliveryTakeOutMaterial(
      _id: $id
      warehouseId: $warehouseId
      remark: $remark
      deliveryTakeOutMaterial: $deliveryTakeOutMaterial
      dateTime: $dateTime
    ) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const RECIEVE_TAKE_OUT = gql`
  mutation ReceiveTakeOutMaterial(
    $id: ID!
    $remark: String
    $receiveTakeOutMaterial: [ReqTakeOutMaterialInput]
  ) {
    receiveTakeOutMaterial(
      _id: $id
      remark: $remark
      receiveTakeOutMaterial: $receiveTakeOutMaterial
    ) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const VOID_TAKE_OUT = gql`
  mutation VoidReqTakeOut($id: ID!, $remark: String) {
    voidReqTakeOut(_id: $id, remark: $remark) {
      status
      message {
        messageKh
        messageEn
      }
    }
  }
`;
